import React from 'react'
import {
  DropdownBody,
  DropdownFooter,
  DropdownItem
} from '../../../components/library/dropdown/content'
import {OverflowFooter} from '../../../components/overflow'
import {
  StreamContainerDetailFragment,
  useDeleteStreamContainerMutation,
  useEditStreamContainerMutation,
  useSetDefaultStreamContainerMutation
} from '../../../data/workbench-api/generated/stream-container'
import {EnvironmentNode} from '../../../environment'
import {useAnalytics} from '../../../lib/analytics/analytics'
import {DeleteLink} from '../components'

export const Overflow = ({
  streamContainer,
  closeDropdown,
  refetch,
  edit,
  canEdit,
  environment
}: {
  streamContainer: StreamContainerDetailFragment
  closeDropdown: () => void
  refetch: () => void
  edit: () => void
  canEdit: boolean
  environment: EnvironmentNode
}) => {
  const analytics = useAnalytics()
  const [updateMutation] = useEditStreamContainerMutation({
    refetchQueries: ['ThemeList'],
    onCompleted: () => {
      analytics.track({
        event: 'Edited configuration',
        properties: {
          org_id: environment.organisationId,
          environment_id: environment.id,
          category: 'configuration>sdk>stream-containers'
        }
      })
    }
  })
  const [deleteMutation] = useDeleteStreamContainerMutation({
    refetchQueries: ['ThemeList'],
    onCompleted: () => {
      analytics.track({
        event: 'Edited configuration',
        properties: {
          org_id: environment.organisationId,
          environment_id: environment.id,
          category: 'configuration>sdk>stream-containers'
        }
      })
    }
  })

  const [setDefaultMutation] = useSetDefaultStreamContainerMutation({
    onCompleted: () => {
      analytics.track({
        event: 'Edited configuration',
        properties: {
          org_id: environment.organisationId,
          environment_id: environment.id,
          category: 'configuration>sdk>stream-containers'
        }
      })
    }
  })

  return (
    <>
      <DropdownBody>
        <DropdownItem disabled={!canEdit}>
          <a
            onClick={() => {
              edit()
              closeDropdown()
            }}
          >
            Edit
          </a>
        </DropdownItem>

        {!streamContainer.isDefault ? (
          <>
            <DropdownItem disabled={!canEdit}>
              <a
                onClick={() => {
                  setDefaultMutation({
                    variables: {
                      environmentId: streamContainer.environmentId,
                      streamContainerId: streamContainer.id
                    }
                  }).then(closeDropdown)
                }}
              >
                Make default
              </a>
            </DropdownItem>
            <DropdownItem disabled={!canEdit}>
              <a
                onClick={() => {
                  updateMutation({
                    variables: {
                      id: streamContainer.id,
                      environmentId: streamContainer.environmentId,
                      enabled: !streamContainer.enabled
                    }
                  }).then(closeDropdown)
                }}
              >
                {streamContainer.enabled ? 'Disable' : 'Enable'}
              </a>
            </DropdownItem>
          </>
        ) : null}

        {!streamContainer.enabled && !streamContainer.isDefault ? (
          <DropdownItem disabled={!canEdit}>
            <DeleteLink
              onClick={() => {
                if (confirm('Deletion is permanent - are you sure?')) {
                  deleteMutation({
                    variables: {
                      id: streamContainer.id,
                      environmentId: streamContainer.environmentId
                    }
                  }).then(() => {
                    refetch()
                    closeDropdown()
                  })
                }
              }}
            >
              Delete
            </DeleteLink>
          </DropdownItem>
        ) : null}
      </DropdownBody>
      <DropdownFooter>
        <OverflowFooter
          id={streamContainer.id}
          created={streamContainer.created}
          updated={streamContainer.updated}
        />
      </DropdownFooter>
    </>
  )
}
